
export const WmsContainerType = {
    TROLLEY: 'trolley',
    SHELF: 'shelf',
    HIVE: 'hive',
    PACKING_STATION: 'packing_station',
    TIPPER: 'tipper',
    CC: 'click_collect',
    STACK: 'stack'
}

export function getWmsContainerType() {
    return [
        WmsContainerType.TROLLEY,
        WmsContainerType.SHELF,
        WmsContainerType.HIVE,
        WmsContainerType.PACKING_STATION,
        WmsContainerType.TIPPER,
        WmsContainerType.CC,
        WmsContainerType.STACK
    ]
}